import { Box, Button, Typography, styled } from '@mui/material';

export const BeneficiariesDataCardDelButtonStyled = styled(Button)(
  ({ theme }) => ({
    marginLeft: theme.spacing(2),
  })
);

export const BeneficiariesDataCardBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4rem',
  padding: '0 1rem',
});

export const BeneficiariesDataCardAmountTextField = styled(Box)(
  ({ theme }) => ({
    marginRight: '1rem',
    width: '11rem',
    [theme.breakpoints.down('sm')]: {
      marginRight: 'auto',
    },
  })
);

export const BeneficiaryDataCardAllocationErrorStyled = styled(Typography)(
  ({ theme }) => ({
    marginTop: '4px',
    fontSize: '1.2rem',
    fontWeight: 400,
    color: theme.palette.error.main,
    [theme.breakpoints.down(1200)]: {
      width: '12rem',
    },
  })
);
